/* eslint-disable react/prop-types */
import { memo } from 'react';

import { useTranslation } from 'react-i18next';

import StripPortal, { STRIPS_ORDER } from 'components/StripPortal';
import { formatDuration } from 'helpers/utils';
import { LastUpdatedIcon } from 'styles/assets/icons';

import OfflineIcon from './OfflineIcon';
import styles from './styles.module.scss';

const MobileView = ({ isOnline, disconnectTime }) => {
  const { t } = useTranslation(['common']);

  if (isOnline) {
    return null;
  }

  const currentTime = new Date().getTime();

  const lastUpdated = disconnectTime
    ? formatDuration(Math.floor((currentTime - disconnectTime) / 1000))
    : 0;

  // this will only be shown when user is logged in and isOffline

  return (
    <StripPortal isSticky>
      <div
        className={styles.mobileContainer}
        style={{ order: STRIPS_ORDER.CONNECTION_STATUS_STRIP }}
      >
        <div className={styles.offlineContent}>
          <div className="flex-set align-items-center me-3">
            <OfflineIcon />
            <div className={styles.disconnectedText}>{t('common:disconnected')}</div>
          </div>
          <div className={`flex-set align-items-center ${styles.mobileLastUpdatedText}`}>
            <LastUpdatedIcon className />
            <span className="ms-1">{t('common:updatedTime', { lastUpdated })}</span>
          </div>
        </div>
      </div>
    </StripPortal>
  );
};

export default memo(MobileView);
